import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { MatTableExporterModule } from 'mat-table-exporter';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MaterialModule } from '../material/material.module';
import { AventuraOsComponent } from './aventura-os/aventura-os.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { DataPersonalRangoComponent } from './data-personal-rango/data-personal-rango.component';
import { DialogPdfComponent } from './dialog-pdf/dialog-pdf.component';
import { ProgramacionAventuraRoutingModule } from './programacion-aventura-routing.module';
import { ProgramacionAventuraComponent } from './programacion-aventura.component';
import { AsignacionPersonalComponent } from './programacion-personal-campo/asignacion-personal/asignacion-personal.component';
import { ProgramacionPersonalCampoComponent } from './programacion-personal-campo/programacion-personal-campo.component';
import { AllComponent } from './programacion/components/all/all.component';
import { DialogTrekkingComponent } from './programacion/components/trekking/dialog-trekking/dialog-trekking.component';
import { TrekkingComponent } from './programacion/components/trekking/trekking.component';
import { ProgramacionComponent } from './programacion/programacion.component';
import { ReportePersonalCampoComponent } from './reporte-personal-campo/reporte-personal-campo.component';
import { OrderPdfModule } from 'src/features/service-order/order-pdf/order-pdf.module';
import { ServiceOrderActionsModule } from 'src/features/service-order/services-os-actions/services-os-actions.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ProgramacionAventuraComponent,
    ProgramacionComponent,
    ConfiguracionComponent,
    AllComponent,
    TrekkingComponent,
    DialogTrekkingComponent,
    DialogPdfComponent,
    DataPersonalRangoComponent,
    ProgramacionPersonalCampoComponent,
    AsignacionPersonalComponent,
    AventuraOsComponent,
    ReportePersonalCampoComponent
  ],
  imports: [
    TablerIconsModule.pick(TablerIcons),
    FormsModule,
    MatTableExporterModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    BrowserModule,
    CommonModule,
    ProgramacionAventuraRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatTableExporterModule,
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    MatDialogModule,
    OrderPdfModule,
    ServiceOrderActionsModule,
    SharedModule
  ]
})
export class ProgramacionAventuraModule {}
